/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateWorkspaceUserPermissionsRequest } from '../../models/update-workspace-user-permissions-request';
import { UpdateWorkspaceUserPermissionsResponse } from '../../models/update-workspace-user-permissions-response';

export interface UpdateWorkspaceUserPermissions$Params {

/**
 * Workspace ID
 */
  workspaceId: number;

/**
 * User ID
 */
  userId: string;
  
    /**
     * Permissions names
     */
    body: UpdateWorkspaceUserPermissionsRequest
}

export function updateWorkspaceUserPermissions(http: HttpClient, rootUrl: string, params: UpdateWorkspaceUserPermissions$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateWorkspaceUserPermissionsResponse>> {
  const rb = new RequestBuilder(rootUrl, updateWorkspaceUserPermissions.PATH, 'patch');
  if (params) {
    rb.path('workspaceId', params.workspaceId, {});
    rb.path('userId', params.userId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpdateWorkspaceUserPermissionsResponse>;
    })
  );
}

updateWorkspaceUserPermissions.PATH = '/workspaces/{workspaceId}/user/{userId}/permissions';
